// http://192.168.0.74:9999// http://zht-api.test.2vm.co/
export default {
  baseUrl: {
    pro: 'http://zht-api.test.bcvip.ink/',
    dev: 'http://zht-api.test.bcvip.ink/',
    uat: 'http://zht-api.test.bcvip.ink/',
  },
  oss: {
    dev: 'https://ydd-oss.2v2.co/',
    pro: 'https://zy-oss.windc.vip/',
    uat:'https://ydd-oss.2v2.co/'
  }
}

